import englishStrings from './en'

export default {
  en: englishStrings,
}
